import type { AppState } from '@app-types/domain';
import { getState, subscribe } from '@core/store';
import { useSyncExternalStore } from 'preact/compat';

export function useStore<T>(selector: (s: AppState) => T): T {
  return useSyncExternalStore(subscribe, () => selector(getState()));
}
